<template>
	<div class="con">
		<div class="head">
			<img class="user-img" :src="userInfo.headimgurl" />
			<div class="head-right">
				<div>{{userInfo.nickname}}</div>
			</div>
			<div class="canvas">
				<canvas id="Theback"></canvas>
			</div>
		</div>

		<div class="list-con">
			<div class="list-li">
				<div class="list-text" v-for="item in list" @click="navTo( item.id, item.to)">
					<img :src="item.img" />
					<div>{{item.text}}</div>
				</div>
			</div>
		</div>

		<div @click="outBtn()" class="out-btn">退出登录</div>
	</div>
</template>

<script>
	export default {
		name: 'doctor',
		data() {
			return {
				msg: '医生界面',
				userInfo: '',
				cardUserInfo: '',
				list: [{
						id: 0,
						text: '在线留言',
						img: require('../assets/registered.png'),
						to: '/chatMessage'
					},
					{
						id: 1,
						text: '对我的反馈',
						img: require('../assets/auscultation.png'),
						to: '/docFeedback'
					},

				]
			}
		},
		methods: {

			navTo(id, e) {
				if (this.cardUserInfo != null) {
					switch (id) {
						case 5:
							this.$router.push({
								path: e,
								query: {
									type: 1
								}
							}, )
							break;
						case 6:
							this.$router.push({
								path: e,
								query: {
									type: 0
								}
							}, )
							break;
						default:
							this.$router.push({
								path: e,
							})
					}

				} else {
					this.$dialog.alert({
						title: "提示",
						message: "您还没有登录卡号",
						confirmButtonText: "确定", //改变确认按钮上显示的文字
						//				         cancelButtonText: "取消" //改变取消按钮上显示的文字
					}).then(() => {
						console.log("点击了确认按钮噢")
					}).catch(() => {
						console.log("点击了取消按钮噢")
					})
				}
			},
			toHome() {
				this.$router.replace({
					path: '/'
				})
			},
			//退出登录
			outBtn(){
				let that = this;
				this.$dialog.confirm({
					title: '提示',
					message: '确定提出登录？'
				}).then(() => {
					that.$toast("退出登录成功")
					localStorage.setItem('emUserInfo', ''); //缓存登录的员工
					that.$router.push({
						path: '/user'
					})
				}).catch(() => {});
				
			},

			wavesurRecord() {
				//获取画布
				var beisizer = document.getElementById("Theback");
				var ContenofBeisizer = beisizer.getContext("2d"); //设置波浪海域（海浪宽度，高度）
				var beisizerwidth = beisizer.width;
				var beisizerheight = beisizer.height;
				var beisizerlinewidth = 2; //曲线
				var sinX = 0;
				var sinY = beisizerheight / 1.2; //轴长
				var axisLenght = beisizerwidth; //弧度宽度
				var waveWidth = 0.014; //海浪高度
				var waveHeight = beisizerheight / 15.0;
				var speed = 0.1; //数值越大速率越快
				var xofspeed = 0; //波浪横向的偏移量
				var rand = beisizerheight; //波浪高度

				ContenofBeisizer.lineWidth = beisizerlinewidth;

				// 创建静态的曲线
				var drawSin = function(xofspeed) {
					ContenofBeisizer.save(); //存放贝塞尔曲线的各个点
					var points = [];
					ContenofBeisizer.beginPath(); //创建贝塞尔点
					for (var x = sinX; x < sinX + axisLenght; x += 80 / axisLenght) {
						//							var y = -Math.sin((sinX + x) * waveWidth);  //测试请解开注释，注释下一行
						var y = -Math.sin((sinX + x) * waveWidth + xofspeed);
						//							points.push([x, sinY + y * waveHeight]); //测试请解开注释，注释下一行
						points.push([x, rand + y * waveHeight]);
						ContenofBeisizer.lineTo(x, sinY + y * waveHeight); //测试请解开注释，注释下一行
						//							 ContenofBeisizer.lineTo(x, rand + y * waveHeight);
					}

					ContenofBeisizer.lineTo(axisLenght, beisizerheight);
					ContenofBeisizer.lineTo(sinX, beisizerheight);
					ContenofBeisizer.lineTo(points[0][0], points[0][1]);
					ContenofBeisizer.stroke();
					ContenofBeisizer.restore(); //贝塞尔曲线样式设置
					ContenofBeisizer.strokeStyle = "#fff";
					ContenofBeisizer.fillStyle = "#fff";
					ContenofBeisizer.fill();
				};

				var rendY = function() {
					ContenofBeisizer.clearRect(0, 0, beisizerwidth, beisizerheight); //控制海浪高度
					var tmp = 0.1;
					rand -= tmp;
					var b = beisizerheight - rand;
					//控制循环涨潮
					if (parseInt(b) == beisizerheight) {
						rand = beisizerheight;
					}
					drawSin(xofspeed);
					xofspeed += speed;
					requestAnimationFrame(rendY);
				};

				// 动态
				drawSin();
				rendY();

			}
		},
		mounted() {
			this.wavesurRecord();
			if (localStorage.getItem('emUserInfo') == '') {
				this.$router.replace({
					path: '/user'
				})
			}
			if (localStorage.getItem('cardUserInfo') != undefined) {
				this.cardUserInfo = localStorage.getItem('cardUserInfo');
				this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
			}
			
			
		}
	}
</script>

<style scoped>
	.con {
		display: flex;
		flex-direction: column;
		flex-wrap: nowrap;
		width: 100%;
		height: 100%;
	}

	.head {
		position: relative;
		display: flex;
		justify-content: space-around;
		align-items: center;
		padding: 20px 0 50px;
		background: linear-gradient(to right, #27BEC4 0%, #8DD7DA 50%, #BDE8E9 100%);
	}

	.canvas {
		position: absolute;
		bottom: -5px;
		z-index: 10;
		width: 100%;
		height: 150px;
	}

	#Theback {
		width: 100%;
		height: 100%;
	}

	.user-img {
		width: 80px;
		height: 80px;
		border-radius: 50%;
		overflow: hidden;
	}

	.head-right {
		font-size: 15px;
	}

	.list-con {
		position: relative;
		flex: 1;
	}

	.licon-sp {
		display: flex;
		justify-content: space-around;
		align-items: center;
		margin: 10px auto;
		padding: 25px 10px;
		background: #fff;
		width: 80%;
		box-shadow: 2px 2px 2px #ccc;
		border-radius: 10px;
		font-size: 15px;
	}

	.list-li {
		display: flex;
		flex-wrap: wrap;
	}

	.list-text {
		margin: 20px 0;
		font-size: 15px;
		text-align: center;
		width: 33%;
	}

	.list-text img {
		margin-bottom: 5px;
		width: 40px;
		height: 40px;
	}
	.out-btn{
		padding: 10px 0;
		width: 100%;
		background-color: #27BEC4;
		color: #fff;
		font-size: 18px;
		text-align: center;
	}
</style>
